import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { FaBars } from 'react-icons/fa';
import './AdminLayout.css';

const AdminLayout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    if (window.innerWidth <= 768) {
      return true;
    }
    return localStorage.getItem('sidebar-collapsed') === 'true';
  });

  const [mobileShow, setMobileShow] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem('sidebar-collapsed', String(next));
      return next;
    });
  };

  return (
    <div className={`admin-layout ${isCollapsed ? 'sidebar-collapsed' : ''} ${mobileShow ? 'mobile-sidebar-show' : ''}`}>
      <header className="mobile-header">
        <button className="mobile-menu-btn" onClick={() => setMobileShow(true)} aria-label="Abrir menú">
          <FaBars />
        </button>
        <span className="mobile-brand-title">MundoTrabajos</span>
      </header>

      {mobileShow && <div className="sidebar-overlay" onClick={() => setMobileShow(false)} />}

      <Sidebar 
        isCollapsed={isCollapsed} 
        onToggle={toggleSidebar} 
        mobileShow={mobileShow} 
        closeMobile={() => setMobileShow(false)} 
      />
      <main className="admin-main">{children}</main>
    </div>
  );
};

export default AdminLayout;
